import { render } from "./BomValidationResultsElementsAmbiguous.vue?vue&type=template&id=3126f429&scoped=true"
import script from "./BomValidationResultsElementsAmbiguous.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsAmbiguous.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsAmbiguous.vue?vue&type=style&index=0&id=3126f429&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3126f429"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem});
